import { createAsyncThunk } from "@reduxjs/toolkit";

import { USER_SETTINGS_KEY } from "core/local_storage_utils";
import { parseJsonString } from "core/str_utils";
import { somDbActions } from "slices/somDb/somDbSlice";

export const fetchBooksForSomDb = createAsyncThunk("books/fetchBooksForSomDb", async (_, { rejectWithValue, extra, dispatch }) => {
	try {
		const { data } = await extra.apiSom.getBooks();

		if (!data) {
			throw new Error();
		}

		const userSettings = parseJsonString(localStorage.getItem(USER_SETTINGS_KEY));

		const columnsData = data.chars.map(({ id, name, char_type: charType, en_alias: enAlias, unit_name: unitName }) => ({
			id,
			name,
			charType,
			enAlias,
			unitName,
			checked: Boolean(userSettings?.somDb?.selectedColumnIds?.includes(id)),
		}));

		dispatch(somDbActions.setColumnsData(columnsData));
		dispatch(somDbActions.setSelectedClassifier(data.classifiers[0]));
		dispatch(somDbActions.setInitColumns());

		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
